module.exports = __webpack_public_path__ + "img/urn.2062d875.svg";